<template>
  <Teleport to="body">
    <div class="wn-overlay" @click.self="$emit('close')">
      <div class="wn-modal" role="dialog" aria-modal="true" aria-labelledby="wn-title">
        <div class="wn-header">
          <div class="wn-header-left">
            <div class="wn-star">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </div>
            <div>
              <h2 id="wn-title" class="wn-title">O que há de novo</h2>
              <p class="wn-subtitle">Versão {{ entry.version }} · {{ entry.date }}</p>
            </div>
          </div>
          <button class="wn-close" type="button" @click="$emit('close')" aria-label="Fechar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div class="wn-body">
          <div v-for="section in entry.sections" :key="section.title" class="wn-section">
            <h3 class="wn-section-title" :class="`wn-section-title--${section.title.toLowerCase()}`">
              {{ section.title }}
            </h3>
            <ul class="wn-list">
              <li v-for="item in section.items" :key="item" class="wn-item">
                <span class="wn-dot"></span>
                {{ item }}
              </li>
            </ul>
          </div>
        </div>

        <div class="wn-footer">
          <button class="wn-btn" type="button" @click="$emit('close')">Entendido</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { CHANGELOG } from '@/store/versionStore'

export default defineComponent({
  name: 'WhatsNewModal',
  emits: ['close'],
  setup() {
    const entry = computed(() => CHANGELOG[0])
    return { entry }
  }
})
</script>

<style scoped lang="scss">
.wn-overlay {
  position: fixed;
  inset: 0;
  z-index: 9000;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: wn-fade-in 0.18s ease;
}

@keyframes wn-fade-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.wn-modal {
  background: var(--card, #fff);
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0,0,0,0.22);
  width: 100%;
  max-width: 520px;
  max-height: 82vh;
  display: flex;
  flex-direction: column;
  animation: wn-slide-up 0.2s ease;
  overflow: hidden;
}

@keyframes wn-slide-up {
  from { transform: translateY(16px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

.wn-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  border-bottom: 1px solid rgba(0,0,0,0.07);
  flex-shrink: 0;
}

.wn-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.wn-star {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.wn-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--ink, #2c2b27);
  margin: 0 0 2px;
}

.wn-subtitle {
  font-size: 12px;
  color: var(--ink-muted, #888);
  margin: 0;
}

.wn-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: rgba(0,0,0,0.05);
  color: var(--ink-muted, #888);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s;

  &:hover { background: rgba(0,0,0,0.1); }
}

.wn-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  scrollbar-width: thin;
}

.wn-section-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 10px;

  &--novo    { color: #16a34a; }
  &--melhorias { color: #2563eb; }
  &--segurança, &--seguranca { color: #dc2626; }
}

.wn-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wn-item {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  font-size: 13px;
  color: var(--ink, #2c2b27);
  line-height: 1.5;
}

.wn-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--accent, #0f4c81);
  flex-shrink: 0;
  margin-top: 5px;
}

.wn-footer {
  padding: 14px 20px;
  border-top: 1px solid rgba(0,0,0,0.07);
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.wn-btn {
  background: var(--accent, #0f4c81);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 24px;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: opacity 0.15s;

  &:hover { opacity: 0.88; }
}
</style>
